import React from 'react'

import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core'
import { Text } from 'components/Typography/Basic'

const PrivacyRightsTable = () => {
  return (
    <TableContainer>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell
              style={{
                width: '30%'
              }}
            >
              <Text as="h6">Right To know</Text>
            </TableCell>
            <TableCell>
              <Text as="p">
                The right to request any or all of the following personal
                information we have collected and disclosed about you in the
                last 12 months:
              </Text>
              <ul>
                <Text as="li">
                  The specific pieces of personal information we have collected
                  about you;
                </Text>
                <Text as="li">
                  The categories and specific pieces of personal information we
                  have collected about you;
                </Text>
                <Text as="li">
                  The categories of sources of the personal information we have
                  collected about you;
                </Text>
                <Text as="li">
                  The categories of personal information we have disclosed about
                  you to third parties for a business purpose, and the
                  categories of recipients to whom this information was
                  disclosed;
                </Text>
                <Text as="li">
                  The categories of personal information we have sold about you
                  (if any), and the categories of third parties to whom this
                  information was sold; and
                </Text>
                <Text as="li">
                  The business or commercial purposes for collecting or, if
                  applicable, selling personal information.
                </Text>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text as="h6">Right To Deletion</Text>
            </TableCell>
            <TableCell>
              <Text as="p">
                The right to request the deletion of personal information we
                have collected from you, subject to certain exceptions.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text as="h6">Right to Opt Out</Text>
            </TableCell>
            <TableCell>
              <Text as="p">
                The right to direct us not to sell personal information we have
                collected about you to third parties.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text as="h6">Right to Non-Discrimination</Text>
            </TableCell>
            <TableCell>
              <Text as="p">
                Any of the rights described above may be exercised without
                discrimination. We are not prohibited from offering you certain
                financial incentives that may result in different prices, rates,
                or quality levels of products or services. Please note that if
                the exercise of these rights limits our ability to process
                personal information (such as in the case of a deletion
                request), we may not be able to provide our products and
                services to individuals who exercise these rights.
              </Text>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default PrivacyRightsTable
